/**
 * Object containing the different `kind` values for a Category BFF resource. This is used as an
 * easy way for the frontend to differentiate the different category variations without needing to
 * inspect its attributes or relationships individually.
 */
export const CATEGORY_KINDS = {
  swimlane: 'swimlane',
  group_swimlane: 'group',
  graph_swimlane: 'graph_swimlane',
  smart_swimlane: 'smart_swimlane',
  derived_swimlane: 'derived_swimlane',
} as const

/** All possible category kinds */
export type CategoryKinds =
  | typeof CATEGORY_KINDS.group_swimlane
  | typeof CATEGORY_KINDS.swimlane
  | typeof CATEGORY_KINDS.graph_swimlane
  | typeof CATEGORY_KINDS.smart_swimlane
  | typeof CATEGORY_KINDS.derived_swimlane

/** Category kinds that can not contain other swimlanes in the hierarchy */
export type LeafCategoryKinds =
  | typeof CATEGORY_KINDS.swimlane
  | typeof CATEGORY_KINDS.graph_swimlane
  | typeof CATEGORY_KINDS.smart_swimlane
